// Only explicit title signals are used; experience and hiring dates are never guessed.
export const inferJobSeniority = (title = '') => {
  const signals = [
    ['C-Level', /\b(?:CEO|CTO|CFO|COO|CMO|CHRO|chief\s+\w+\s+officer)\b/i],
    ['VP', /\b(?:VP|vice president)\b/i],
    ['Director', /\bdirector\b/i],
    ['Manager', /\bmanager\b/i],
    ['Lead', /\b(?:lead|principal)\b/i],
    ['Senior', /\b(?:senior|sr\.?)\b/i],
    ['Junior', /\b(?:junior|jr\.?)\b/i],
    ['Intern', /\b(?:intern|internship)\b/i]
  ];
  return signals.find(([, pattern]) => pattern.test(title))?.[0] || '';
};
